import { School } from './../../../models/school';
import { ExcelService } from './../../../services/excel.service';
import { NgxRolesService } from 'ngx-permissions';
import { AuthService } from './../../../services/auth.service';
import { Observable } from 'rxjs/Observable';
import { DataTablesResponse } from './../../../models/DataTablesResponse';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Passenger } from './../../../models/passenger';
import { Component, OnInit, OnDestroy, ViewChild, NgZone } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Select2OptionData } from 'ng2-select2';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { PNotifyService } from '../../../services/pnotify.service';
import { Journey } from './../../../models/journey';
const jsPDF = require('jspdf');
require('jspdf-autotable');
declare const google: any;

@Component({
  selector: 'app-subscription-list',
  templateUrl: './subscription-list.component.html',
  styleUrls: ['./subscription-list.component.css']
})
export class SubscriptionListComponent implements OnInit {

  isAssistant: boolean;
  routeBase: string;

  filter = {
    clientId: '',
    schoolId: '',
    busId: '',
    name: '',
    code: '',
    inscriptionStatus: '',
    inscriptionType: 'renew or new',
    dateInterval: [],
    isAssistant: false,
    isActive: true,
    isAdmin: false,
    isReserved: false,
  };
  staticFilter: any;
  currentPassengers: any;
  inscriptionTypeSelected: any;
  passengerIdSelected: any;
  public clientsData: Array<Select2OptionData>;
  public schoolsData: Array<Select2OptionData>;
  public busesData: Array<Select2OptionData>;
  public InscriptionStatusData: Array<Select2OptionData>;
  public InscriptionTypeData: Array<Select2OptionData>;
  public InscriptionTypeModalData: Array<Select2OptionData>;
  public InscriptionCurrentPassengerModalData: Array<Select2OptionData>;

  adminStatus = true;
  stats = { new: 0, renew: 0, waiting: 0 };

  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;

    // ----- Start Option Scrollbar -----------
    isScrollbar: true;
    scrollbarOptions = {
      axis: 'y',
      theme: 'minimal-dark'
    };
    // ----- End Option Scrollbar -----------

  selectedAll = false;
  selectedMulti = false;

  dtOptions: any = {};
  dtCurrentpage: any;
  dtCurrentLen: any;
  dtIntiFlag: any;
  clients: any[];
  schools: any[];
  buses: any[];
  passengers: any[];
  pnotify = undefined;
  isResponsible = false;
  directionsService: any;
  directionsRenderer: any;
  isReserved = false;
  selectedSchool: any;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private roleService: NgxRolesService,
    private excelService: ExcelService,
    private router: Router,
    private route: ActivatedRoute,
    private zone: NgZone,
    pnotifyService: PNotifyService
  ) { 
    this.isAssistant = false;
    this.routeBase = 'subscription';
    this.dtIntiFlag = false;
    this.route.params.subscribe(params => {
      this.dtCurrentpage = params['PgNo'];
      this.dtCurrentLen = params['PgLen'];
    });
    this.initClientSelect();

    this.InscriptionStatusData = [
      { id: '', text: 'Choisir une option' },
      { id: 'PNV', text: 'Position non defini'},
      { id: 'Attente', text: 'Attente validation'},
      { id: 'Valid', text: 'Validé'}
      ];

    this.InscriptionTypeData = [
      { id: 'renew or new', text: 'Choisir une option' },
      { id: 'new', text: 'Nouveau'},
      { id: 'renew', text: 'Renouvellement'}
      ];
    
    this.InscriptionTypeModalData = [
      { id: '', text: 'Choisir une option' },
      { id: 'new', text: 'Nouveau'},
      { id: 'renew', text: 'Renouvellement'}
      ];

    this.pnotify = pnotifyService.getPNotify();
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      this.isResponsible = true;
    }
  }

  ngOnInit(): void {
    this.route.data
      .subscribe((data: { isAssistant: boolean }) => {
        //this.routeBase = data.isAssistant ? 'assistant' : 'passenger';
        this.isAssistant = data.isAssistant;
        this.filter.isAssistant = data.isAssistant;
      });
    if (this.roleService.getRole('ROLE_ADMIN')) {
      this.filter.isAdmin = true; 
    }

     // Event lors de la fin d'init du dt
     $('table').on('init.dt', (event) => this.initPaginationTable());

    const columns = [
      { data: 'checkbox' },
      { data: 'inscriptionDate' },
      { data: 'lastname' },
      { data: 'firstnames' },
      // { data: 'count' }, nombre de passager
      { data: 'phone' },
      { data: 'busName' },
      { data: 'inscriptionType' },
      { data: 'inscriptionStatus' },
      { data: 'activationKey' },
      //{ data: 'SmsToSend' },
      { data: 'actions' },
    ];
    if (this.isAssistant) {
      // columns.splice(7, 1);
      columns.splice(0, 1);
    }
    if (this.roleService.getRole('ROLE_ADMIN')) {
      columns.splice(1, 0, { data: 'clientName' }); 
    }
    
    this.dtOptions = {
      searching: false,
      pageLength: Number(this.dtCurrentLen),
      serverSide: true,
      processing: true,
      lengthMenu: [[5, 10, 25, 50, 100], [5, 10, 25, 50, 100]],
      order: [[1, 'asc']],
      ordering: false,
      columnDefs: [
        { 'orderable': false, 'targets': 0 }
      ],
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.filter = this.staticFilter;
        this.http.post<DataTablesResponse>(
          '/api/passenger',
          dataTablesParameters,
          {}
        ).subscribe((resp: any) => {
          this.passengers = resp.data;
          if (resp.stats) this.stats = resp.stats;
          let dta = [];
          this.passengers.forEach((passenger, index) => {
            const btnModifierETArchiver = `<a class="btn btnAction btnNavigate" data-url="/${this.routeBase}/subscription-edit-passenger/${passenger.id}">
                                  <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>Modifier
                                </a>
                                <button class="btn btnAction btnArchive" data-passenger-id="${passenger.id}">
                                  <i class="fa fa-archive fa-2x" aria-hidden="true"></i>Archiver
                                </button>`;
            const btnModifierETSupprimer = `<a class="btn btnAction btnNavigate" data-url="/${this.routeBase}/subscription-edit-passenger/${passenger.id}">
                                  <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>Modifier
                                </a>
                                <button class="btn btnAction btnDelete" data-passenger-id="${passenger.id}">
                                  <i class="fa fa-trash fa-2x" aria-hidden="true"></i>Supprimer
                                </button>`;
            
            let inscriptionType = '';
            switch (passenger.inscriptionType) {
              case 'new':
                inscriptionType = `<label>nouveau</label>`;
              break;
              case 'renew':
                inscriptionType = `<label>Renouvellement</label>`;
              break;
              default:
                inscriptionType = `<label>-</label>`;
            }

            let inscriptionStatus = '';
            switch (passenger.inscriptionStatus) {
              case 'PNV':
                inscriptionStatus = `<label style="color:red">Position non valide</label>`;
              break;
              case 'Attente':
                inscriptionStatus = `<label style="color:orange">Attente validation</label>`;
              break;
              case 'Valid':
                inscriptionStatus = `<label style="color:green">Validé</label>`;
              break;
              default:
                inscriptionStatus = `<label style="color:black">-</label>`;
            }
            // Show only when module is active
            if (this.selectedSchool.subscriptionOn !==  0){
              dta.push({
                id: passenger.id,
                checkbox: `<label class="el-switch" style="font-size:80%">
                            <input  type="checkbox"
                                    name="checkboxs[]"
                                    value="${passenger.id}"
                                    ${this.selectedAll ? 'checked' : ''}
                            >
                            <span class="el-switch-style"></span>
                          </label>`,
                busSchoolName: passenger.School ? passenger.School.name : '',
                busName: passenger.Bus ? passenger.Bus.name : '',
                inscriptionDate: passenger.inscriptionDate,
                lastname: passenger.lastname,
                firstnames: passenger.firstnames,
                // count: passenger.count,
                phone: passenger.phone,
                subscription: passenger.subscription,
                inscriptionType: inscriptionType,
                inscriptionStatus: inscriptionStatus,
                positionStatus: (passenger.isPositionValide ? `<label style="color:green">Définie</label>`
                : `<label style="color:red">Non définie</label>`),
                activationKey: passenger.activationKey,
                /*SmsToSend: passenger.SmsToSend == 0 ? `<label style="color:green">Envoyé</label>`
                : `<label style="color:orange">En-cours</label>`,*/
                actions: this.isAssistant ? `
                  <a class="btn btnAction btnNavigate" data-url="/${this.routeBase}/subscription-view-passenger/${passenger.id}">
                    <i class="fa fa-search fa-2x" aria-hidden="true"></i>Détail
                  </a>
                  ${(this.adminStatus) ? btnModifierETSupprimer : ''}
                  ${passenger.inscriptionType !== 'new' ? 
                      `<button class="btn btnAction btnDesinscription" data-passenger-id="${passenger.id}">
                        <i class="fa fa-user-times" aria-hidden="true"></i>Désinscrire
                      </button>` : ''
                  }
                `
                : `
                <a class="btn btnAction btnNavigate" data-url="/${this.routeBase}/subscription-view-passenger/${passenger.id}">
                  <i class="fa fa-search fa-2x" aria-hidden="true"></i>Détail
                </a>
                ${(this.adminStatus) ? btnModifierETArchiver : ''}
                ${passenger.inscriptionType !== 'new' ? 
                      `<button class="btn btnAction btnDesinscription" data-passenger-id="${passenger.id}">
                        <i class="fa fa-user-times" aria-hidden="true"></i>Désinscrire
                      </button>` : ''
                }
              `
              });
              
              if (this.roleService.getRole('ROLE_ADMIN')) {
                dta[index].clientName = passenger.School.Client.name;
              }
            }                  
            
          });

          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: dta
          });
        });
      },
      fnCreatedRow: function (nRow, aData, iDataIndex) {
        $(nRow).attr('id', 'passenger_' + aData.id);
      },
      columns: columns,
      dom: '<t> <"row" <"col-md-4"l><"col-md-8"p>>',
      language: {
        'sProcessing': 'Traitement en cours...',
        'sSearch': 'Rechercher&nbsp;:',
        'sLengthMenu': 'Afficher _MENU_ &eacute;l&eacute;ments',
        'sInfo': 'Affichage de l\'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments',
        'sInfoEmpty': 'Affichage de l\'&eacute;l&eacute;ment 0 &agrave; 0 sur 0 &eacute;l&eacute;ment',
        'sInfoFiltered': '(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)',
        'sInfoPostFix': '',
        'sLoadingRecords': 'Chargement en cours...',
        'sZeroRecords': 'Aucun &eacute;l&eacute;ment &agrave; afficher',
        'sEmptyTable': 'Aucune donn&eacute;e disponible dans le tableau',
        'oPaginate': {
          'sFirst': 'Premier',
          'sPrevious': 'Pr&eacute;c&eacute;dent',
          'sNext': 'Suivant',
          'sLast': 'Dernier'
        },
        'oAria': {
          'sSortAscending': ': activer pour trier la colonne par ordre croissant',
          'sSortDescending': ': activer pour trier la colonne par ordre d&eacute;croissant'
        }
      },
      // Use this attribute to enable the responsive extension
      responsive: true
    };
    $('table').on('click', '.btnDesinscription', (event) => {
      this.onDesinscription($(event.currentTarget).data('passengerId'));
    });
    $('table').on('click', '.btnDelete', (event) => {
      this.onDelete($(event.currentTarget).data('passengerId'));
    });
    $('table').on('click', '.btnArchive', (event) => {
      this.onArchive($(event.currentTarget).data('passengerId'));
    });
    $('table').on('click', '.btnNavigate', (event) => {
      this.onNavigate($(event.currentTarget).data('url') + '/' + this.dtCurrentpage + '/' + this.dtCurrentLen);
    });
    $('table').on('change', '[name="checkboxs[]"]', (event) => this.onCheckChange());

    $('table').on('draw.dt', (event) => this.onDtDrawChange());
  }

  ngOnDestroy(): void {
    $.fn['dataTable'].ext.search.pop();
    $('table').off();
  }

  initPaginationTable(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      const pgsInfo = dtInstance.page.info();
      const totalPg = pgsInfo.pages;
      let pgNo  = 0;

      if (this.dtCurrentpage === 'last' ) {
        pgNo = totalPg - 1;
      } else {
        pgNo = Number(this.dtCurrentpage);
      }
      // dtInstance.page.len(Number(this.dtCurrentLen));
      dtInstance.page(pgNo);
      // Show only when module is active
      //if (this.selectedSchool.subscriptionOn ===  0){
     
      dtInstance.draw(false);
      this.dtIntiFlag = true;
   });
  }

  updatePaginationInfo(): void {
    if (this.dtIntiFlag === true) {
      this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
        const pgsInfo = dtInstance.page.info();
        this.dtCurrentpage = pgsInfo.page;
        this.dtCurrentLen = pgsInfo.length;
     });
    }
  }

  initClientSelect() {
    if (this.roleService.getRole('ROLE_CLIENT') || this.roleService.getRole('ROLE_SUPER_CLIENT')) {
      const client = this.authService.getUser();
      this.clients = [{ id: client.id, name: client.name }];
      this.filter.clientId = client.id;
      this.initSchoolSelect();
    } else if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      const client = this.authService.getUser().School.Client;
      this.clients = [{ id: client.id, name: client.name }];
      this.filter.clientId = client.id;
      this.adminStatus = this.authService.getUser().isRespAdmin;
      this.initSchoolSelect();
    } else {
      this.http.get(
        '/api/client/lookup'
      ).subscribe((clients: any[]) => {
        this.clients = clients;
        const array1 = [{ id: '', text: 'Choisir un client' }];
        const array2 = this.clients.map(function (client, index) {
          return { id: client.id, text: client.name };
        });
        this.clientsData = array1.concat(array2);
        // this.initSchoolSelect();
      });
    }
    //this.staticFilter = this.filter;
  }

  clientChanged(e: any) {
    this.filter.clientId = e.value;
    this.initSchoolSelect();
  }

  initSchoolSelect() {
    this.filter.schoolId = '';
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      const school = this.authService.getUser().School;
      this.schools = [{ id: school.id, name: school.name }];
      this.filter.schoolId = school.id;
      this.initBusSelect();
    } else {
      const params = new HttpParams({
        fromObject: {
          clientId: this.filter.clientId
        }
      });
      this.http.get(
        '/api/school/lookup',
        { params }
      ).subscribe((schools: any[]) => {
        this.schools = schools;
        this.filter.schoolId = schools && schools.length ? schools[0].id : '';
        this.schoolsData = this.schools.map((school, index) => {
          return { id: school.id, text: school.name, selected: school.id === this.filter.schoolId };
        });

        // Get selected school
        this.selectedSchool = this.findSchoolById(this.filter.schoolId);
        console.log ("schoolsData",this.schoolsData);
        //this.initBusSelect();
      });
    }

    this.staticFilter = this.filter;
  }

  // Function to find a school by name
  findSchoolById(schoolId) {
    return this.schools.find(school => school.id === schoolId);
  }

  schoolChanged(e: any) {
    this.filter.schoolId = e.value;
    // Get selected school
    this.selectedSchool = this.findSchoolById(e.value);
    this.initBusSelect();
  }

  initBusSelect() {
    this.filter.busId = '';
    let params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId,
        schoolId: this.filter.schoolId
      }
    });
    this.http.get(
      '/api/bus/lookup',
      { params }
    ).subscribe((buses: any[]) => {
      this.buses = buses;
      const array1 = [{ id: '', text: 'Choisir une option' }];
      const array2 = this.buses.map(function (bus, index) {
        return { id: bus.id, text: bus.name };
      });
      this.busesData = array1.concat(array2);
    });
  }

  // A completer
  initPassengerSelect() {
    this.staticFilter.inscriptionType = "-";

    this.http.post(
      '/api/passenger',
      { filter: this.staticFilter }
    ).subscribe((resp: any) => {
      //console.log ("resp.data",resp.data);
      this.currentPassengers = resp.data;
      const array1 = [{ id: '', text: 'Selectionner un nom' }];
      const array2 = this.currentPassengers.map(function (passenger, index) {
        return { id: passenger.id, text: passenger.lastname + ' ' + passenger.firstnames };
      });
      this.InscriptionCurrentPassengerModalData = array1.concat(array2);
    });

    this.staticFilter.inscriptionType = "renew or new";// remettre type to default value
  }

  busChanged(e: any) {
    this.filter.busId = e.value;
  }

  inscriptionStatusChanged(e: any) {
    this.filter.inscriptionStatus = e.value;
  }

  inscriptionTypeChanged(e: any) {
    this.filter.inscriptionType = e.value;
  }

  inscriptionTypeModalChanged(e: any) {
    this.inscriptionTypeSelected = e.value;

    if (e.value == "renew"){
      this.initPassengerSelect();
    }
  }

  inscriptionCurrentPassengerModalChanged(e: any) {
    this.passengerIdSelected = e.value;
  }

  onAddPassengerSelected() {
    let selectedpassenger;
    this.currentPassengers.forEach((currentPassenger) => {
      if (this.passengerIdSelected == currentPassenger.id){
        selectedpassenger = currentPassenger;
        selectedpassenger.inscriptionStatus = 'Attente';
        selectedpassenger.inscriptionType = 'renew';
        selectedpassenger.inscriptionDate = moment().format('YYYY-MM-DD'); // today inscription
      }
    });
    this.http
      .put(
        '/api/passenger/' + this.passengerIdSelected,
        { passenger: selectedpassenger }
      )
      .subscribe(
        result => {
          //this.inscriptionTypeSelected = '' ;
          this.passengerIdSelected = '' ;
          this.initPassengerSelect();
          $('#ModalAddPassager').modal('hide');// close Modal
        }
      );
  }

  onAddNewPassenger() {
    $('#ModalAddPassager').modal('hide');// close Modal
  }
  
  onSelectedAllChange() {
    $('[name="checkboxs[]"]').prop('checked', this.selectedAll);
    this.onCheckChange();
  }

  onCheckChange() {
    const length = $('[name="checkboxs[]"]:checked').length;
    if (length > 1 && !this.isAssistant) {
      this.selectedMulti = true;
    } else {
      this.selectedMulti = false;
    }
  }

  onDtDrawChange() {
    this.onCheckChange();
    this.updatePaginationInfo();
  }

  onNavigate(url) {
    this.zone.run(() => this.router.navigateByUrl(url));
  }

  onDelete(id) {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous supprimer cet element ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                this.delete(id);
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  onDesinscription(id){
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Souhaitez-vous désinscrire ce(s) passager(s) de la prochaine entrée scolaire ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                this.desinscription(id);
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  onArchive(id) {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Ce passager sera dissocié de tous ces trajets. Voulez-vous archiver cet element ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                this.archive(id);
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  onBulkArchive() {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous archiver la selection ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                $('[name="checkboxs[]"]:checked').each((i, elt: any) => {
                  this.archive($(elt).val());
                });
                this.selectedMulti = false;
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  desinscription(id) {
    let selectedpassenger;
    this.passengers.forEach((passenger) => {
      if (id == passenger.id){
        selectedpassenger = passenger;
        selectedpassenger.inscriptionStatus = '-';
        selectedpassenger.inscriptionType = '-';
      }
    });
    this.http.put(
        '/api/passenger/' + id,
        { passenger: selectedpassenger }
      ).subscribe(
        (resp: any)  => {
          //this.updateAffectedjourneys(resp.AffectedJourneyIds);
          document.getElementById('passenger_' + id).remove();
        }
      );
      this.pnotify.notice({
      title: 'Information',
      text: 'operation réussie !',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  archive(id) {
    let selectedpassenger;
    this.passengers.forEach((passenger) => {
      if (id == passenger.id){
        selectedpassenger = passenger;
        selectedpassenger.isActive = 0;
      }
    });
    this.http
      .put(
        '/api/passenger/archive/' + id,
        { passenger: selectedpassenger }
      )
      .subscribe(
        (resp: any)  => {
          this.updateAffectedjourneys(resp.AffectedJourneyIds);
          document.getElementById('passenger_' + id).remove();
        },
        error => {
          this.pnotify.error({
            title: 'Erreur',
            text: 'Une erreur est survenue !',
            stack: {
              firstpos1: 70, firstpos2: 10,
              modal: true,
              overlay_close: true
            },
            hide: false,
            modules: {
              Confirm: {
                confirm: true,
                buttons: [
                  {
                    text: 'Ok',
                    addClass: 'btn btn-chico',
                    click: notice => {
                      notice.close();
                    }
                  }
                ]
              }
            }
          });
        }
      );
  }

  updateAffectedjourneys(AffectedJourneyIds: any) {
    let journey: any;
    let results: any;

    for (let i = 0; i < AffectedJourneyIds.length; i++) {
      this.http.get(
        '/api/journey/findOne/' + AffectedJourneyIds[i]
      ).subscribe((_journey: Journey) => {
        journey = _journey;

        results = this.calculateNewRoute(journey);
      });
    }
  }

  calculateNewRoute(_journey: Journey) {
    const journey: Journey = _journey;
    this.directionsService = new google.maps.DirectionsService;
    this.directionsRenderer = new google.maps.DirectionsRenderer({ suppressMarkers: true });
    const waypts = [];
    let PositionPassager: any;

    journey.start = new Date(Number(_journey.start) * 1000);
    journey.JourneyPassengers.forEach((JourneyPassenger) => {
      PositionPassager = new google.maps.LatLng(Number(JourneyPassenger.Passenger.lat), Number(JourneyPassenger.Passenger.lng));
      waypts.push({
        location: PositionPassager,
        stopover: true
      });
    });

    this.directionsService.route({
      origin: { lat: Number(journey.startPositionLat), lng: Number(journey.startPositionLng) },
      destination: { lat: Number(journey.endPositionLat), lng: Number(journey.endPositionLng) },
      waypoints: waypts,
      optimizeWaypoints: true,
      travelMode: 'DRIVING'
    }, (response, status) => {
      let distancetrajet: any = 0;
      let TimeEstimatedPassager: any = this.getElapsedSecondsInDay(journey.start);
      if (journey.type === ('M1' || 'AM1')) {
        journey.waitTimePassager = 20;
      } else {
        journey.waitTimePassager = 0;
      }
      if (status === 'OK') {
        // this.directionsRenderer.setDirections(response);
        // Calcule: Temps estimé de fin de trajet / Arrivé a chaque arret / distance total estimé
        if (waypts.length > 0) {
          const route = response.routes[0];
          // 1- Ajouter la distance et la durée du point depart au premier passager
          distancetrajet = distancetrajet + route.legs[0].distance.value;
          TimeEstimatedPassager = TimeEstimatedPassager + route.legs[0].duration.value;
          journey.JourneyPassengers[0].estimatedTime = new Date(Number(TimeEstimatedPassager) * 1000);
          // 2- Ajouter la distance et la durée pour chaque point d'arret
          for (let i = 1; i <= route.legs.length - 2; i++) {
            distancetrajet = distancetrajet + route.legs[i].distance.value;
            TimeEstimatedPassager = TimeEstimatedPassager + route.legs[i].duration.value + journey.waitTimePassager;
            journey.JourneyPassengers[i].estimatedTime = new Date(Number(TimeEstimatedPassager) * 1000);
          }
          // 3- Ajouter la distance et la durée pour aller au point destinations
          distancetrajet = distancetrajet + route.legs[route.legs.length - 1].distance.value;
          TimeEstimatedPassager = TimeEstimatedPassager + route.legs[route.legs.length - 1].duration.value;

          journey.distance = Number((distancetrajet / 1000).toFixed(0));
          journey.end = new Date(Number(TimeEstimatedPassager) * 1000);

        }
        journey.start = this.getElapsedSecondsInDay(journey.start);
        journey.end = this.getElapsedSecondsInDay(journey.end);
        journey.JourneyPassengers.forEach((journeyPassenger, index) => {
          journey.JourneyPassengers[index].estimatedTime = this.getElapsedSecondsInDay(journeyPassenger.estimatedTime);
          journeyPassenger.order = index + 1;
        });
        // Update server
        this.http.put(
          '/api/journey/' + journey.id,
          { journey: journey }
        ).subscribe(() => {},
          (error) => {
            this.pnotify.error({
              title: 'Erreur',
              text: 'Une erreur est survenue !',
              stack: {
                firstpos1: 70, firstpos2: 10,
                modal: true,
                overlay_close: true
              },
              hide: false,
              modules: {
                Confirm: {
                  confirm: true,
                  buttons: [
                    {
                      text: 'Ok',
                      addClass: 'btn btn-chico',
                      click: notice => {
                        notice.close();
                      }
                    }
                  ]
                }
              }
            });
          }
        );
      } else {
        console.log ('Directions request failed due to ' + status);
      }
    });
  }

  getElapsedSecondsInDay(date) {
    const day = moment(date);
    const startOfDay = day.clone().startOf('day');
    return day.diff(startOfDay, 'seconds');
  }

  onCodeSMS(id){
    let selectedpassenger;
    this.passengers.forEach((passenger) => {
      if (id == passenger.id){
        selectedpassenger = passenger;
        selectedpassenger.SmsToSend = 1;
        // window.alert(selectedpassenger.lastname + ' ' + selectedpassenger.SmsToSend);
      }
    });

    this.http.put(
        '/api/passenger/' + id,
        { passenger: selectedpassenger }
      ).subscribe();
      this.pnotify.notice({
      title: 'Information',
      text: 'La demande d\'envoie SMS est enregirstré',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }
  

  onBulkDelete() {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous supprimer la selection ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                $('[name="checkboxs[]"]:checked').each((i, elt: any) => {
                  this.delete($(elt).val());
                });
                this.selectedMulti = false;
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  delete(id) {
    this.http
      .delete('/api/passenger/' + id)
      .subscribe(
        result => {
          document.getElementById('passenger_' + id).remove();
        },
        error => {
          this.pnotify.error({
            title: 'Erreur',
            text: 'Une erreur est survenue !',
            stack: {
              firstpos1: 70, firstpos2: 10,
              modal: true,
              overlay_close: true
            },
            hide: false,
            modules: {
              Confirm: {
                confirm: true,
                buttons: [
                  {
                    text: 'Ok',
                    addClass: 'btn btn-chico',
                    click: notice => {
                      notice.close();
                    }
                  }
                ]
              }
            }
          });
        }
      );
  }

  onFilter(): void {
    this.filter.isReserved = this.isReserved;
    if (this.filter.dateInterval.length == 2) {
      this.filter.dateInterval = [
        moment(this.filter.dateInterval[0]).format('YYYY-MM-DD'),
        moment(this.filter.dateInterval[1]).format('YYYY-MM-DD')
      ];
    }
    this.staticFilter = this.filter;
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
       dtInstance.draw();
    });
  }

  onPassengerExportPerFilter() {
    this.http.post(
      '/api/passenger',
      { filter: this.staticFilter }
    ).subscribe((resp: any) => {

      const passagers = [
        [
          'id',
          'Date inscription',
          'Nom',
          'Prénom(s)',
          'Nombre de place',
          'Tél',
          'Bus',
          'Type inscription',
          'Status inscription'
        ]
      ];

      for (let i = 0; i < resp.data.length; i++) {
        
        let inscriptionType = '';
            switch (resp.data[i].inscriptionType) {
              case 'new':
                inscriptionType = `nouveau`;
              break;
              case 'renew':
                inscriptionType = `Renouvellement`;
              break;
              default:
                inscriptionType = `-`;
            }

            let inscriptionStatus = '';
            switch (resp.data[i].inscriptionStatus) {
              case 'PNV':
                inscriptionStatus = `Position non valide`;
              break;
              case 'Attente':
                inscriptionStatus = `Attente validation`;
              break;
              case 'Valid':
                inscriptionStatus = `Validé`;
              break;
              default:
                inscriptionStatus = `-`;
            }
        passagers.push([
          resp.data[i].id,
          resp.data[i].inscriptionDate,
          resp.data[i].lastname,
          resp.data[i].firstnames,
          resp.data[i].count,
          resp.data[i].phone,
          resp.data[i].Bus ? resp.data[i].Bus.name : '',
          inscriptionType,
          inscriptionStatus,
        ]);
      }

      let fileName, sheetName = '';

      if (resp.data[0].School.name) {
        fileName = 'Liste Parents inscrit ' + resp.data[0].School.name;
      } else {
        fileName = 'Liste Parents inscrit ';
      }
      
      const currentDate = new Date();
      const day = String(currentDate.getDate()).padStart(2, '0');
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const year = currentDate.getFullYear();

      fileName = `${fileName} ${day}-${month}-${year}`;
      
      sheetName = `${day}-${month}-${year}`;

      this.excelService.exportAsExcelFileWithMultiplePage([
        {
          name: sheetName,
          data: passagers
        },
        ], fileName);

    });

  }

}




// WEBPACK FOOTER //
// ./src/app/components/subscription/subscription-list/subscription-list.component.ts